import styled from 'styled-components'

const text_de = (
  <>
    Die Daten werden vertraulich behandelt und im Fragebogen werden keine
    Angaben erfragt, welche Rückschlüsse auf die Person ermöglichen. Es werden
    keine persönlichen Daten wie die IP-Adresse gespeichert und die Eingaben
    werden nicht mit Ihren Abo-Daten in Verbindung gebracht.{' '}
    <b>Ihre Teilnahme erfolgt völlig anonym.</b> Eine nachträgliche Löschung der
    eingegebenen Daten nach dem Absenden ist deshalb nicht möglich. Teilnahme ab
    18 Jahren möglich.
    <br />
    <br />
    <b>
      Mit der Teilnahme erklären Sie sich einverstanden, dass Ihre anonymen
      Eingaben für wissenschaftliche Zwecke ausgewertet werden dürfen.
    </b>
  </>
)

// 'Die Daten werden vertraulich behandelt und im Fragebogen werden keine Angaben erfragt, welche Rückschlüsse auf die Person ermöglichen. Es werden keine persönlichen Daten wie die IP-Adresse gespeichert und die Eingaben werden nicht mit deinen Abo-Daten in Verbindung gebracht. Deine Teilnahme erfolgt völlig anonym.'

const text_fr = (
  <>
    Les données sont traitées de manière confidentielle et le questionnaire ne
    demande pas d'informations permettant de tirer des conclusions sur la
    personne. Aucune donnée personnelle telle que l'adresse IP n'est stockée et
    les réponses ne sont pas associées à vos données d'abonnement.{' '}
    <b>Votre participation est totalement anonyme.</b> Par conséquent, il n'est
    pas possible de supprimer les données saisies après l'envoi. Le sondage est
    réservé aux personnes dès 18 ans.
    <br />
    <br />
    <b>
      En participant, vous acceptez que vos données soient évaluées à des fins
      scientifiques.
    </b>
  </>
)

const question_de = 'Sind sie damit einverstanden?'
const question_fr = "Êtes-vous d'accord?"

const DataDeclaration = ({
  lang,
  check,
  show = true,
  colorMode,
}: {
  lang: 'de' | 'fr'
  check: (e: boolean) => void
  show?: boolean
  colorMode?: 'light' | 'dark' | undefined
}) => {
  return (
    <DataDeclarationContainer>
      {lang === 'de' ? text_de : text_fr}
      <ButtonRow>
        {lang === 'de' ? question_de : question_fr}
        <br />
        <Button onClick={() => check(true)}>
          {lang === 'de' ? 'Ja' : 'Oui'}
        </Button>
        <Button onClick={() => check(false)}>
          {lang === 'de' ? 'Nein' : 'Non'}
        </Button>
      </ButtonRow>
    </DataDeclarationContainer>
  )
}

const Button = styled.button`
  font-family: var(--font-sans-serif);
  background-color: #fff;
  color: var(--brandblue-main);
  padding: 10px 20px;
  border: 0;
  min-width: 100px;
  margin-right: 2px;
  font-size: 18px;
  margin-top: 15px;
  @media screen and (max-width: 711px) {
    font-size: 15px;
  }
`

const ButtonRow = styled.div`
  width: 100%;
  text-align: center;
  padding-top: 30px;
  font-size: 22px;
  @media screen and (max-width: 711px) {
    font-size: 15px;
  }
`
const DataDeclarationContainer = styled.div`
  position: sticky;
  top: 100px;
  z-index: 40;
  z-index: 2003;
  font-size: 18px;
  letter-spacing: 0.3px;
  /* font-style: italic; */
  line-height: 1.5em;
  padding: 30px;
  /* border: 1px solid var(--beige-bright-1); */
  /* background-color: var(--beige-bright-3); */
  color: var(--beige-dark-1);
  max-width: 630px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0px;
  margin-bottom: 0px;
  margin-bottom: 30px;
  @media screen and (max-width: 711px) {
    /* padding-left: 0;
    padding-right: 0; */
    margin-top: 30px;
    font-size: 15px;
    max-width: calc(100vw - 40px);
    margin-left: 20px;
    margin-right: 20px;
    padding: 15px;
  }
  border-radius: 10px;
  background-color: var(--purple-main);
  color: #fff;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.4);
  box-shadow: 0px 10px 15px rgba(167, 87, 163, 0.2),
    0px 30px 80px rgba(0, 0, 0, 0.2);
`

export default DataDeclaration
